import {
  Box,
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Chip,
  useTheme,
} from "@mui/material";
import {
  PlayArrow as PlayIcon,
  CheckCircle as CheckIcon,
} from "@mui/icons-material";
import { ExamStatusBadge, ExportPdfButton } from "../common";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLazyGetExamAttemptByIdQuery, useRestartExamMutation } from "@/store/api/user/examApi";
import { downloadExamPdf } from "@/utils/pdfExport";
import { clearExamDraft } from "@/pages/user/ExamSession/examLocalStore";

export const ExamItem = ({ test }) => {
  const isAdmin = useSelector((state) => state.auth.user?.role === "admin");
  const theme = useTheme();
  const navigate = useNavigate();
  const [restartExam] = useRestartExamMutation();
  const [getCurrentAttempt] = useLazyGetExamAttemptByIdQuery();

  const handlePressButton = async (isRestart) => {
    if (isRestart) {
      const attempt = await getCurrentAttempt(test._id).unwrap();
      if (attempt?.data?.length) {
        clearExamDraft(attempt.data[0]._id);
        await restartExam(attempt.data[0]._id);
      }
    }
    navigate(`/exam-session/${test._id}`);
  }
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        background: "rgba(255,255,255,0.9)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255,255,255,0.3)",
        transition: "all 0.3s ease",

        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
        },
      }}
    >
      {/* Score Circle for Completed Exams */}
      <CardContent sx={{ flexGrow: 1, position: "relative" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="h6" component="h3" sx={{ fontWeight: 600 }}>
              {test.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {test.description}
            </Typography>
          </Box>

          {test.attemptInfo?.rawStatus === "completed" &&
            test.attemptInfo?.score && (
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  minWidth: 80,
                  minHeight: 80,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#1976D2",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  border: "3px solid #1976D2",
                  zIndex: 1,
                }}
              >
                {test.attemptInfo.score}/990
              </Box>
            )}
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1,
            mb: 2,
            flexWrap: "wrap",
          }}
        >
          <Chip
            label={`${
              test.totalQuestions || test.questions?.length || 0
            } questions`}
            size="small"
            variant="outlined"
            sx={{
              borderRadius: 2,
              borderColor: "#4CAF50",
              color: "#4CAF50",
              fontWeight: 500,
            }}
          />
          {/* Status Badge */}
          {test.attemptInfo?.rawStatus && (
            <ExamStatusBadge
              status={test.attemptInfo.rawStatus}
              showIcon={true}
            />
          )}
        </Box>
      </CardContent>

      <CardActions sx={{ p: 2, gap: 1 }}>
        <ExportPdfButton
          iconOnly
          isAdmin={isAdmin}
          onExport={() => downloadExamPdf(test._id, test.title)}
          onExportWithAnswers={isAdmin ? () => downloadExamPdf(test._id, test.title, true) : undefined}
          label="Export PDF"
        />
        {(() => {
          const status = test.attemptInfo?.rawStatus;
          const isRestart = status === "completed";
          return (
            <Button
              onClick={() => handlePressButton(isRestart)}
              fullWidth
              startIcon={<PlayIcon />}
              variant={"contained"}
              // disabled={status === "completed" && !isAdmin}
              sx={{
                borderRadius: 2,
                py: 1.5,
                fontWeight: 600,
                textTransform: "none",
                fontSize: "1rem",
                ...(test.attemptInfo?.rawStatus === "completed"
                  ? {
                      backgroundColor: isRestart ? theme.palette.error.main : "#667eea",
                      borderColor: "#667eea",
                      color: "white",
                    }
                  : {
                      background:
                        status === "in_progress"
                          ? "linear-gradient(135deg, #e081e9 0%, #e04e5f 100%)"
                          : "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #8e44ad 100%)",
                      "&:hover": {
                        opacity: 0.8,
                      },
                    }),
              }}
            >
              {status === "in_progress"
                ? "Retake"
                : isRestart
                ? "Restart"
                : "Start Test"}
            </Button>
          );
        })()}
      </CardActions>
    </Card>
  );
};
